<template>
  <div style="height:100%">
    <div class="d-flex justify-content-between py-2" ref="titleBox" v-if="action==='add'||action==='edit'">
      <input
          ref="editor_title"
          class="editorTitle"
          type="text"
          v-model="curentArticle.title"
          :placeholder="'请输入标题'"
          @keyup="watchModify"
      />
    </div>
    <editor
        :init="editorConfig"
        v-model="curentArticle.msgbody"
    />
    <div class="mt-2">
      <span class="editor-footer pt-2" v-if="action==='add'||action==='edit'" >
        <el-tooltip content="如何使用标签" placement="bottom">
          <el-button round class="explain">
            <el-popover
                placement="right"
                trigger="click"
                effect="light"
                v-model="visiblepop">
              <div class="recommend">
                <div class="mt-2 px-2"><h2 class="font-weight-bold border-bottom pb-3">
                  如何使用标签 <i role='button' @click="qxPopOver" class="el-icon-close mr-0 float-right"></i>
                </h2>
                </div>
                <div><i class="el-icon-user"></i><span>作者给自己的帖子添加和内容相关的标签。</span></div>
                <div><i class="el-icon-view"></i><span>添加合适的标签，能方便分类检索，帖子也更容易被读者发现</span></div>
                <div><i class="el-icon-key"></i><span>点击 "选择帖子相关标签" 输入您想添加的标签即可</span></div>
                <div class="col-12 pt-4 col-md-12 mx-0 mt-0"><img style="width:500px" src="/img/tag.webp" class="logo"></div>
              </div>
              <i size="medium" style="font-size: 24px" class="el-icon-warning-outline text-secondary"
                 slot="reference"></i>
            </el-popover>
          </el-button>
        </el-tooltip>
        <!--        <span>-->
        <el-select
            v-model="tagname"
            multiple
            filterable
            remote
            reserve-keyword
            allow-create
            :remote-method="getTagOptions"
            :loading="loadingOption"
            placeholder="请添加与帖子相关标签">
            <el-option
                v-for="item in options"
                :key="item.id"
                :label="item.name"
                :value="item.name">
               </el-option>
        </el-select>

        <!--      </span>-->
      </span>

      <!-- <span class="pl-4">
        <el-switch class="mr-2"
        v-model="command_allowed">
        </el-switch><span :style="{color:command_allowed?'black':'grey'}">评论</span>
      </span> -->
      <span class="float-right">
        <button class="btn btn-simple px-3 py-2" type="default" @click="cancle()" v-if="this.action!='comment'">
          <i class="el-icon-close mr-1"></i>取消
        </button>
         <el-button class="btn btn-primary ml-2" v-if="curentArticle.postID!==0" type="primary" simple @click="submit()"
                    :disabled="curentArticle.title==''">
          <i class="el-icon-edit mr-1"></i>
          {{
             this.action === 'add' ? '发帖子' : this.action === 'edit' ? '保存' : this.action === 'comment' ? '发评论' : this.action === 'reply' ? '回复' : '回复'
           }}
         </el-button>
      </span>
    </div>
  </div>
</template>
<script>
import Editor from '@tinymce/tinymce-vue';
import blog from "@/module/blog/blog.service";
import tinymce from './tinymce/tinymce.min'
import 'tinymce/themes/silver'
import './tinymce/icons/default/icons.js'
import './tinymce/plugins/image/plugin.js'
import './tinymce/plugins/media'
import 'tinymce/plugins/advlist'
import 'tinymce/plugins/autolink'
import 'tinymce/plugins/lists'
import 'tinymce/plugins/link'
import 'tinymce/plugins/anchor'
import 'tinymce/plugins/charmap'
import 'tinymce/plugins/print'
import 'tinymce/plugins/emoticons'
import 'tinymce/plugins/emoticons/js/emojis.js'
import 'tinymce/plugins/fullscreen'
// import './tinymce/plugins/fontsizeselect'

import 'tinymce/plugins/searchreplace'
import 'tinymce/plugins/visualblocks'
import 'tinymce/plugins/code'
import 'tinymce/plugins/insertdatetime'
import 'tinymce/plugins/table'
import 'tinymce/plugins/help'
import 'tinymce/plugins/wordcount'
import 'tinymce/plugins/paste'
import 'tinymce/plugins/searchreplace'
import 'tinymce/plugins/preview'
import './langs/zh_CN.js'
import './langs/zh_TW.js'
import "tinymce/skins/ui/oxide/skin.css"
import "tinymce/skins/ui/oxide/content.css"
import "tinymce/skins/content/default/content.css"

export default {
  name: "wxc-editor",
  props: {
    groupID: Number,
    postID: Number,
    data: {},
    action: String,
    type: {
      type: Number,
      default: 2  //2：群吧 1：博客
    }
  },
  components: {
    'editor': Editor,
  },
  created() {
    this.$store.dispatch('article/InitArticaleData', {
      groupinfoID: Number(this.data.groupinfoID),
      typeID: this.type,
      action: this.action
    })
    this.initData();
  },
  mounted() {
    if (this.action === 'edit') {
      this.curentArticle = {
        title: this.data.postInfo_postID.title,
        msgbody: this.data.postInfo_postID.msgbody,
        tagname: [],
        postID: this.data.postID,
        typeID: 2,
      }
      this.data.postInfo_postID.tags.forEach(x => {
        this.tagname.push(x.name);
      })
    }
    if (this.$route.query.topic) {
      let topic = this.$store.state.group.groupTopBar.tags.filter(x => x.id == Number(this.$route.query.topic));
      if (topic) this.tagname.push(topic[0].tag_tagID.name)
    }
    // this.curentArticle.groupinfoID = this.data.groupinfoID
  },
  methods: {
    test() {
      this.submit()
    },
    initData() {
      this.editorConfig.toolbar = "image media link";
      if (this.action === "comment" || this.action === 'reply') {
        this.curentArticle = {
          msgbody: this.action === 'reply2' ? `@${this.data.userinfo_userID.username}　` : '',
          postID: this.data.postID,
          typeID: this.type
        }
      }
      if (this.action === 'reply2') {
        this.curentArticle = {
          msgbody: this.action === 'reply2' ? `@${this.data.userinfo_userID.username}　` : '',
          postID: this.data.basecode,
          typeID: this.type
        }
      }
      if (this.action === "editreply") {
        this.curentArticle = {
          msgbody: this.data.postInfo_postID.msgbody,
          postID: this.data.postID,
          typeID: this.type
        }
      }
    },
    cancle() {
      this.$emit('cancled', true)
      // this.$message.success('发帖已取消');
    },
    submit() {
      if (!this.check_user_login()) return;
      if (this.action === 'add') {
        this.curentArticle.tagname = this.tagname;
        this.$store.dispatch('article/AddArticle', {
          article_data: this.curentArticle,
          module_data: this.module_data
        }).then(res => {
          if (res.status) {
            this.initData();
            if (this.$route.path.indexOf('/group/index')) {
              this.$router.push(`/group/list/${this.data.groupinfoID}?topic=${this.$route.query.topic}`);
            } else {
              this.$router.push(`/group/list/${this.data.groupinfoID}?topic=0`);
            }
            this.$store.dispatch('group/GetArticalList', {groupinfoID: this.data.groupinfoID, topicID: 0, lastID: 0});
            this.$emit('submited', res)
            this.$message.success('帖子已发布');
            setTimeout(()=>{
              location. reload()
            },300)

          } else {
            alert(res.error)
          }
        })
      }
      if (this.action === 'edit') {
        this.curentArticle.tagname = this.tagname;
        this.$store.dispatch('article/UpdateArticle', {
          article_data: this.curentArticle,
          module_data: this.module_data
        }).then(res => {
          this.$emit('submited', res)
        });
      }
      if (this.action === 'comment' || this.action === 'reply' || this.action === 'reply2') {
        this.$store.dispatch('group/ReplyAdd', {article_data: this.curentArticle}).then(res => {
          this.initData();
          this.$emit('submited', res)
          this.$message.success('评论发布成功');
        })
      }
      if (this.action === 'editreply') {
        this.$store.dispatch('group/EditReply', {article_data: this.curentArticle}).then(res => {
          this.initData();
          this.$emit('submited', res)
          this.$message.success('评论修改成功');
        })
      }
    },
    getTagOptions(query) {
      if (query != '') {
        this.loadingOption = true;
        this.$store.state.search.get_tags(query).then(res => {
          this.loadingOption = false;
          this.options = res.data;
        })
      } else {
        this.options = []
      }

    },
    watchModify(val) {
      // this.watchCount+=1;
    },
    filePicker: function (callback, value, meta) {
      // Provide file and text for the link dialog
      var input = document.createElement('input');
      input.setAttribute('type', 'file');
      if (meta.filetype == 'image') {
        input.setAttribute('accept', 'image/*');
      } else {
        input.setAttribute('accept', 'audio/*');
      }

      var that = this

      input.onchange = function () {
        var file = this.files[0];
        var fileType = file.name;
        var reader = new FileReader();
        reader.onload = function () {
          // var id = 'blobid' + (new Date()).getTime();
          // var blobCache =  tinymce.activeEditor.editorUpload.blobCache;
          var base64 = reader.result.split(',')[1];
          that.uploadFile(meta.filetype, reader.result, callback);
        }
        reader.readAsDataURL(file);
      };

      input.click();
    },

    uploadImage(blobInfo, success, failure, progress) {
      this.uploadFile("image", blobInfo.base64(), success, failure, progress);
    },

    uploadFile(fileType, file, success, failure, progress) {
      document.tinymceEditor.topLevelWindow.block("Uploading file ...");
      if (fileType == 'media') {
        this.loading.media = true;
        blog.uploadMedia(file).then(rs => {
          document.tinymceEditor.topLevelWindow.unblock();
          success(rs.data);
          this.loading.media = false;
        }).catch(error => {

        })
      } else {
        blog.uploadImage(file).then(rs => {
          document.tinymceEditor.topLevelWindow.unblock();
          success(rs.data);
        }).catch(error => {

        })
      }
    },
    qxPopOver(){
      this.visiblepop=false;
    },
  },
  data() {
    let lang = localStorage.lang ? (localStorage.lang == "cns" ? 'zh_CN' : 'zh_TW') : 'zh_CN';
    return {
      visiblepop: false,
      command_allowed: false,
      options: '',
      loadingOption: false,
      tagname: [],
      curentArticle: {
        title: "",
        msgbody: "",
        tagname: [],
        typeID: 2,
      },
      module_data: {
        groupinfoID: Number(this.data.groupinfoID)
      },

      editorConfig: {
        selector: '#editorText',
        browser_spellcheck: true, // 拼写检查
        branding: false, // 去水印
        elementpath: false,  //禁用编辑器底部的状态栏
        statusbar: false, // 隐藏编辑器底部的状态栏
        paste_data_images: false, // 允许粘贴图像
        menubar: false,
        image_uploadtab: true,
        images_upload_handler: this.uploadImage,
        // language_url : './langs/zh_CN.js',
        plugins: [
          'advlist autolink lists link image charmap print preview anchor paste',
          'searchreplace visualblocks code fullscreen',
          'insertdatetime media table paste help wordcount'
        ],
        toolbar_mode: "wrap",
        toolbar:
            'undo redo  bold italic underline strikethrough  paste pastetext  alignleft aligncenter alignright alignjustify  \
             image media link file\
            formatselect  backcolor forecolor  bullist numlist outdent indent  removeformat  searchreplace help ',
        language: lang,
        relative_urls: false,
        remove_script_host: true,
        image_dimensions: false,
        file_picker_callback: this.filePicker,
        fontsize_formats: 'x-Large Medium x-Small',
        media_dimensions: false,
        media_live_embeds: true,
        image_class_list: [
          // {title: 'wide', value:'wide-img'},
          // {title: 'medium', value:'medium-img'},
          // {title: 'narrow', value:'narrow-img'},
          {title: 'origin', value: 'origin-img'}
        ],
        setup: function (editor) {
          document.tinymceEditor = {};
          editor.on('OpenWindow', function (eventDetails) {
            document.tinymceEditor.topLevelWindow = eventDetails.dialog;
          })
          editor.on('keyup', function (e) {
            // editoronChange(e);
          })
        },
        image_description: false,
        // media_poster:false,
        content_style: '.mce-content-body .mce-offscreen-selection {position: absolute;left: -9999999999px;max-width: 1000000px;} ' + ' body{font-size:medium;} .wide-img{width:100%; height:auto;} .narrow-img{width:30%; height:auto;} .medium-img{width:60%; height:auto;} .origin-img{max-width:100%; height:auto;}',
        video_template_callback: function (data) {
          return "";
        }
      }
    }
  }

}
</script>
<style>
.btn-primary.disabled div {
  background-color: rgba(255, 255, 255, 0);
}

button.el-button.btn.btn-primary {
  padding: 10px 10px;
}

.editorTitle {
  font-size: 30px;
  padding: 5px 10px;
  border: 1px solid #d3d3d3;
  /* border:0; */
  width: 100%;
  border-radius: 0px;
}

input.editorTitle:focus {
  color: #495057;
  outline: 0;
}

.el-date-table td.disabled div span {
  color: #ffffff8f !important;
}

body {
  margin: 0;
}
</style>